module.exports = __webpack_public_path__ + "static/img/openai-logo.fe2c8ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/openai-logo.png
// module id = Q3Em
// module chunks = 1